import { render, staticRenderFns } from "./FlexList.vue?vue&type=template&id=597c8060&scoped=true"
import script from "./FlexList.vue?vue&type=script&lang=js"
export * from "./FlexList.vue?vue&type=script&lang=js"
import style0 from "./FlexList.vue?vue&type=style&index=0&id=597c8060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c8060",
  null
  
)

export default component.exports